import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';

export const TOGGLE_GOOGLE_SHEETS = 'toggleGoogleSheets';

export const googleSheetsApi = createApi({
  reducerPath: 'googleSheetsApi',
  baseQuery,
  endpoints: (builder) => ({
    [TOGGLE_GOOGLE_SHEETS]: builder.mutation<any, any>({
      query: ({ datasourceId, savedQueryId, payload }) => ({
        url: `datasources/${datasourceId}/views/${savedQueryId}/toggle-googlesheets`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useToggleGoogleSheetsMutation } = googleSheetsApi;
